<template src="./NotificationsList.html"> </template>

<script>

import { mapState, mapActions } from 'vuex';

import NotificationsCreate from '../NotificationsCreate/NotificationsCreate.vue';

export default {
    name: 'NotificationsList',
    components: {
        NotificationsCreate
    },
    data() {
        return {
           notificationsCreate: { status: false, row: undefined },
        }
    },
    methods: {
        ...mapActions({
            getNotifications: state => state.notifications.getNotifications,

            loadNotifications: 'getNotifications',
        }),

        onViewNotificationCreate() {
            this.notificationsCreate.status = !this.notificationsCreate.status;
        },

        tableRowClick(row) {
            row['variable']['id'] = 'chillH'
            row['interval'] = 'hourly'
            this.$emit('clicked', row)
        }
        
    },
    computed: {
        ...mapState({
            ws: state => state.ws.ws,
            
            notifications: state => state.notifications.notifications,
            notificationsLoading: state => state.notifications.notificationsLoading,

            variables: state => state.variables.variables,
        }),

        getDataTable() {
            //console.log('this.notifications: ', this.notifications)
            if (this.notifications.length == 0) return []

            const tableHeader = [{text: "Virtual Weather Station", value: 'ws'}, {text: "Description", value: "description"}, { text: "Climate Indicator", value: "variable"}, {text: "Start Date", value: 'begin'}, {text: "End Date", value: 'end'}, {text: "View Dashboard"}  ]; //, {text: "Send Alert every", value: 'sendalert'}, {text: "Day (s)", value: 'days'}],
            
            let tableData = [];
            this.notifications.forEach(notification => {
                tableData.push({
                    //id: notification._id,
                    ws: this.ws.find(item => item._id == notification.ws),
                    description: notification.description,
                    variable: this.variables[notification.variable],
                    begin: notification.begin,
                    end: notification.end,
                    //notifications: notification.notifications,
                    //alertOn: notification.alertOn
                });
            });

            return {
                header: tableHeader,
                data: tableData
            }
        }
    },

    mounted() {
        this.loadNotifications()
    }
}
</script>

<style lang="scss" src="./NotificationsList.scss"> </style>